<pf-content>
    @if (label(); as label) {
        <div id="print-label-container">
            <article pfArticle pfTitle="Print Settings" id="print-settings">
                <platform-print-label-settings
                    #printSettings
                    [labelCount]="1"
                    (settingsChanged)="
                        onSettingsChanged($event)
                    "></platform-print-label-settings>
            </article>

            <article pfArticle pfTitle="Preview" id="preview">
                <div id="preview-container">
                    <platform-zpl-preview
                        [zpl]="label.zpl"
                        [fileName]="label.barcode"
                        [widthInches]="data.widthInches"
                        [heightInches]="
                            data.heightInches
                        "></platform-zpl-preview>
                </div>
                <div id="preview-action-buttons">
                    <pf-button
                        buttonType="print"
                        [disabled]="!printSettings.valid"
                        [loading]="printing()"
                        (click)="printLabel()">
                        Print
                    </pf-button>
                </div>
            </article>
        </div>
    }
</pf-content>
